<template>
  <v-container>
    <v-layout justify-center wrap row>
      <v-flex xs12 text-xs-center headline ma-3 v-if="needsOnboarding">
        Welcome to the new Brainingcamp!
      </v-flex>
      <v-flex xs12 elevation-3 pa-3 style="max-width: 550px">
        <form v-on:keyup.enter="setPassword">
          <v-layout column wrap pa-3>
            <v-flex xs12 text-xs-center subheading mb-3>
              Please choose a password.
            </v-flex>
            <v-flex xs12 mb-4 v-if="error">
              <v-alert
                :value="error"
                type="error"
                outline
              >
                {{ error }}
              </v-alert>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                outline
                color="secondary"
                label="Password"
                type="password"
                v-model="password"
                :rules="[rules.required]"
                autofocus
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                outline
                color="secondary"
                label="Confirm Password"
                type="password"
                v-model="password2"
                :rules="[rules.required]"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 mt-1 text-xs-center>
              <v-btn class="secondary ma-0"
                v-if="!loading"
                dark
                @click="setPassword">Submit</v-btn>
              <v-progress-circular
                v-if="loading"
                indeterminate
                color="secondary"
              ></v-progress-circular>
            </v-flex>
          </v-layout>
        </form>
      </v-flex>
      <v-flex xs12 sm10 my-3 v-if="needsOnboarding">
        <p class="display-1 my-3">What's New</p>
        <p class="body-2">Easily Add Teacher Accounts</p>
        <p class="body-1 mb-3">Schools can now easily add teachers by simply pasting a list of email address.</p>
        <p class="body-2">Shared Generic Student Accounts</p>
        <p class="body-1 mb-3">No more individual student accounts. Instead you create shared generic logins for your classes or for the entire school. This means student use the program anonymously without any privacy concerns. It also makes it incredibly fast and easy to get your students setup.</p>
        <p class="body-2">Longer Sessions</p>
        <p class="body-1">You now stay logged-in longer, so that you're not constantly having to enter your Username and Password. Of course, you can still sign out any time you want.</p>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import AuthenticationService from '@/services/AuthenticationService'

export default {
  data () {
    return {
      loading: false,
      error: null,
      password: null,
      password2: null,
      needsOnboarding: false,
      rules: {
          required: value => !!value || 'Required.'
      }
    }
  },
  components: {
  },
  mounted: function () {
    this.needsOnboarding = this.$store.getters.onboardStatus
  },
  methods: {
    async setPassword () {
      if (this.password !== this.password2) {
        this.error = 'Both passwords must match'
        return;
      }

      this.error = null
      this.loading = true
      try {
        const response = await AuthenticationService.setPassword({
          password: this.password
        })

        this.$store.dispatch('setToken', response.data.token)
        this.$store.dispatch('setUser', response.data.user)
        
        this.$router.push({
          name: 'root'
        })

      } catch(err) {
        this.error = err.response.data.error;
      }

      this.loading = false
    }
  }
}
</script>

<style scoped>

</style>

